<template>
    <div class="main w">
        <div class="bread_box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="user_top">
            <el-upload class="avatar-uploader" :action="upload.url" :headers="config" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <div class="headImg_box">
                    <img class="mainImg" :src="user.avatar" alt="" srcset="">
                    <div class="camera">
                        <img src="@/assets/img/cameraIcon.png" alt="" srcset="">
                    </div>
                </div>
            </el-upload>
            <div class="textItem">
                <div class="item">
                    <span class="label">用户名：</span>
                    <span class="text">{{ user.nickname }}</span>
                </div>
                <div class="item">
                    <span class="label">账号ID：</span>
                    <span class="text">{{ user.id }}</span>
                </div>
                <div class="item">
                    <span class="label">注册时间：</span>
                    <span class="text" v-if="user.createTime">{{ user.createTime.substr(0, 16) }}</span>
                </div>
            </div>
            <div class="textItem">
                <div class="item">
                    <span class="label">手机号码：</span>
                    <span class="text">{{ $u.hidePhone(user.phone, 3, 4) }}</span>
                </div>
                <div class="item">
                    <span class="label">累计学习时长：</span>
                    <span class="text">{{ user.learnHour || 0 }}</span>
                </div>
                <div class="item">
                    <span class="label">累计学分：</span>
                    <span class="text">{{ user.learnScore || 0 }}</span>
                </div>
            </div>
        </div>
        <div class="conMenu">
            <div class="menu">
                <ul>
                    <li v-for="(item, index) in tabs" :key="index"
                        :class="$route.path.indexOf(item.path) != -1 ? 'liCheck' : ''">
                        <router-link :to="item.path" class="item">
                            <span>{{ item.name }}</span>
                            <i class="el-icon-arrow-right"></i>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="conBox">
                <router-view />
            </div>
        </div>

    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { getToken } from '@/utils/auth'
import { userUpdate } from "@/api/user";
export default {
    data() {
        return {
            tabs: [{ name: '培训记录', path: '/user/trainingRecord' }, { name: '我的考试', path: '/user/myExamination' }, { name: '个人设置', path: '/user/userSet' }, { name: '修改密码', path: '/user/forgotPwd' }, { name: '学习评价', path: '/user/feedback' }],
            upload: {
                // 上传的地址
                url: process.env.VUE_APP_BASE_API + "/api/common/upload",
            },
            token: "",
            imageUrl: '',
        }
    },
    computed: {
        ...mapGetters([
            'user'
        ]),
        config() {
            return { token: this.token };
        }
    },
    mounted() {
        // console.log(this.user);
        this.token = getToken();
    },
    methods: {
        ...mapActions(['GetInfo']),
        handleAvatarSuccess(res, file) {
            if (res.code == 200) {
                console.log(res.data.url);
                userUpdate({
                    avatar: res.data.url
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功！')
                        this.GetInfo();
                    } else {
                        this.$message.error(res.message);
                    }

                })
            }
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            console.log("============================打印了");
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
            }
            return isJPG && isLt2M;
        }
    }
}
</script>
<style lang="scss" scoped>
.user_top {
    display: flex;
    align-items: center;
    background: url('@/assets/img/userTopBg.png') no-repeat;
    background-size: cover;
    height: 176px;
    border-radius: 4px;
    padding: 0 20px;

    .headImg_box {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 50%;

        .mainImg {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }

        .camera {
            position: absolute;
            right: -4px;
            bottom: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 31px;
            height: 31px;
            border-radius: 50%;
            background: #FCDBDB;
            border: 2px solid #fff;

            img {
                width: 11px;
            }
        }
    }

    .textItem {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 50px;
        height: 78px;

        &:last-child {
            margin-left: 154px;
        }

        .item {
            display: flex;
            align-items: center;
            font-size: 14px;

            .label {
                width: 120px;
                letter-spacing: 2px;
                text-align: right;
            }

        }
    }
}

.conMenu {
    display: flex;
    margin-top: 13px;
    padding-bottom: 60px;

    .menu {
        // height: 320px;
        width: 312px;
        background: #fff;

        ul {
            li {
                padding: 10px 0;

                .item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 60px;
                    font-size: 16px;
                    padding: 0 20px;
                    transition: all .2s;
                }
            }

            .liCheck {
                .item {
                    background: #CD2312;
                    color: #fff;
                }
            }
        }
    }

    .conBox {
        flex: 1;
        overflow: hidden;
        margin-left: 13px;
        background: #fff;
    }
}
</style>